<template>
    <div class="header-nav">
        <div class="logo-box">
            <img style="width: 210px; height: 46px;" :src="store.langData.logo1" alt="Logo" class="logo">
            <!-- <div class="select-box">
                {{ store.lang == 'zh' ? "中文" : "English" }}
                <div class="list">
                    <div class="icon"></div>
                    <span :class="{ check: store.lang == 'zh' }" @click="setLang('zh')">中文</span>
                    <span :class="{ check: store.lang == 'en' }" @click="setLang('en')">English</span>
                </div>
            </div> -->
        </div>
        <div class="nav-btns">
            <div class="item" v-for="(item, index) in store.langData.header_nav" :style="{color: path == item.path  ? '#aaaaaa' : '#333333'}" @click="navigator(item.path)" :key="index">{{ item.label }}</div>
        </div>
    </div>
</template>

<script setup>
    import { reactive, watch, ref } from 'vue';
    import { useRouter,useRoute } from 'vue-router'
    import { useStore } from '@/store/index'
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const path = ref('/')
    const state = reactive({
        path: '/',
        navigator: [
            {
                label: 'Home', // 首页
                path: '/'
            },
            {
                label: 'Global Influencer Matching', // 全球影响力匹配
                path: '/global-influencer'
            },
            {
                label: 'Full-Process Marketing', // 全流程营销服务
                path: '/full-process'
            },
            {
                label: 'Join as Influencer', // 达人入驻申请
                path: '/influencer'
            },
            {
                label: 'Nexalink', // nexalink
                path: '/nexalink'
            },
            {
                label: 'Deepblue', // deepblue
                path: '/deepblue'
            },
            {
                label: 'About Us', // 达人申请表单
                path: '/about'
            }
        ]
    });
    watch(
        () => route.path,
        (newPath) => {
            path.value = newPath
        }
    )
    const setLang = (e) => {
        store.setLang(e)
    }
    const navigator = (path) => {
        router.push({ path: path })
    }
</script>

<style lang="scss" scoped>

    .header-nav {
        width: 100vw;
        height: 80px;
        gap: 40px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0px 100px;
        box-sizing: border-box;
        background-color: #f5f5f5;
        border-bottom: 1px solid #eee;
        .logo-box {
            display: flex;
            align-items: center;
            gap: 30px;
            .logo {
                margin-right: 10px;
            }
        }
        .nav-btns {
            display: flex;
            justify-content: space-around;
            align-items: center;
            flex: 1;
            height: 100%;
            gap: 40px;
            .item {
                cursor: pointer;
                font-size: 18px;
                font-weight: 800;
                flex-shrink: 0;
            }
        }
        .select-box {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 105px;
            height: 34px;
            border-radius: 8px;
            border: 1px solid #999999;
            flex-shrink: 0;
            font-family: SourceHanSansCN, SourceHanSansCN;
            font-weight: bold;
            font-size: 16px;
            color: #333333;
            line-height: 24px;
            text-align: left;
            font-style: normal;
            user-select: none;
            cursor: pointer;
            &::after {
                width: 100%;
                height: 100%;
                content: '';
                position: absolute;
                left: 0;
                top: 20px;
            }
            .list {
                display: none;
                position: absolute;
                width: 105px;
                left: 0;
                top: 55px;
                z-index: 2;
                padding: 5px 0px;
                border-radius: 6px;
                box-sizing: border-box;
                background-color: #f5f5f5;
                box-shadow: 0px 0px 6px 3px rgb(200, 200, 200, 0.3);
                span {
                    display: inline-block;
                    width: 105px;
                    height: 40px;
                    flex-shrink: 0;
                    font-family: SourceHanSansCN, SourceHanSansCN;
                    font-weight: bold;
                    font-size: 16px;
                    color: #333333;
                    line-height: 24px;
                    text-align: left;
                    font-style: normal;
                    user-select: none;
                    cursor: pointer;
                    text-align: center;
                    line-height: 40px;
                    &:hover {
                        color: #3290fc;
                        background-color: #EEEEEE;
                    }
                }
                .check {
                    color: #3290fc;
                    background-color: #EEEEEE;
                }
                .icon {
                    position: absolute;
                    left: 50%;
                    top: -20px;
                    width: 0;
                    height: 0;
                    transform: translateX(-50%);
                    border: 10px solid transparent;
                    border-bottom-color: #f5f5f5;
                }
            }
            &:hover .list {
                display: block;
            }
        }
    }
</style>